<button class="flex items-center gap-1">
  <market-icon iconName="map-pin" [attr]="{ color: 'blue' }"></market-icon>
  <p>Hà Nội</p>
</button>
